import React from "react";
import Members from "src/components/Group/Users";
import type { UID } from "src/types";

interface Props {
  users: Array<UID>;
}

const Users = ({ users }: Props): React.ReactElement => {
  return <Members users={users} />;
};

export default Users;
